import { render, staticRenderFns } from "./set-source.vue?vue&type=template&id=621783ad&scoped=true&"
import script from "./set-source.vue?vue&type=script&lang=js&"
export * from "./set-source.vue?vue&type=script&lang=js&"
import style0 from "./set-source.vue?vue&type=style&index=0&id=621783ad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621783ad",
  null
  
)

export default component.exports